import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import { useTranslation } from "react-i18next"

import { openNav } from "../../scripts/sideNavMenu.js"

import useDocumentScrollThrottled from "../../scripts/useDocumentScrollThrottled"
import SchoolHeaderLinks from "./SchoolHeaderLinks"

import SummerSchoolHeaderLinks from "./SummerSchoolsHeaderLinks"

import MenuIcon from "../../svg/menu-left.inline.svg"
import MenuIconDark from "../../svg/menu-left-black.inline.svg"

import UserLoginName from "../UserLoginName"
import ChangeChoiceLanguage from "../../components/ChangeChoiceLanguage"

import { useSidemenu } from "../../components/SidemenuContext"

const SchoolHeaderSection = props => {
  const { toggleApplyDocsMenu } = useSidemenu()
  const [pathname, setPathname] = useState("")
  useEffect(() => {
    setPathname(window.location.pathname)
  }, [])

  const [shouldBeActive, setShouldBeActive] = useState(false)
  const { t, i18n } = useTranslation()
  const lang = i18n.language

  useDocumentScrollThrottled(callbackData => {
    const { currentScrollTop } = callbackData

    setShouldBeActive(currentScrollTop > 50)
  })

  const shrinked = shouldBeActive ? "shrinked" : ""
  const hide = shouldBeActive ? "hide" : ""

  return (
    <div
      className={`header-wrapper ${props.schoolSectionHeader}`}
      style={{
        backgroundImage: `linear-gradient(180deg, rgba(11, 16, 32, 1) 0%, rgba(11, 16, 32, 0.7) 19%, rgba(11, 16, 31, 0) 100%), url(${props.school.resolvedImageUrl})`,
      }}
    >
      <div
        id="header"
        className={` header school-item-header container pt-4 px-5 ${shrinked} ${props.schoolSectionHeader}`}
      >
        <div className="row d-flex justify-content-between">
          {!shrinked && props.isMainSchoolTab && (
            <div className="logo-menu-block f-ac f-js col-md-5 col-lg-3">
              <Link to={`/${lang}/`}>
                <div
                  className={`logo_full mR-20 ${hide} ${props.schoolSectionHeaderLogo}`}
                >
                  <div className="logo_full_block logo_full_block_1">Smart</div>
                  <div className="logo_full_block logo_full_block_2">
                    Admissions
                  </div>
                  <div className="logo_full_block logo_full_block_3">
                    Service
                  </div>
                  <div className="logo_shrinked_block">
                    <pre>S A S</pre>
                  </div>
                </div>
              </Link>
              <div
                className={`icon_button menu ${props.schoolSectionHeader}`}
                onClick={openNav}
              >
                <MenuIcon className={`menu_icon`} />
                <MenuIconDark className={`menu_icon shrinked-menu-icon`} />
                <div className="menu_title right">
                  {t("school.header.menu")}
                </div>
              </div>
            </div>
          )}
          <div className="shrinked-header-wrapper">
            <div className="school-item-part">
              <div className="school-name-logo-wrapper f-ac f-jc">
                <div className="school-logo f-ac f-jc">
                  <img
                    src={props.school.resolvedLogoUrl}
                    alt="school-logo-mini-icon"
                    className="school-logo-mini-icon-image"
                  />
                </div>
                <div className="school-item-header-name">
                  {props.school.name}
                </div>
              </div>
              <div
                className="school-apply-button f-ac f-jc curs-P"
                onClick={toggleApplyDocsMenu}
              >
                <div className="apply-button-text">
                  {t("school.header.apply")}
                </div>
              </div>
            </div>
            {props.school.isSummer ? (
              <SummerSchoolHeaderLinks props={props} />
            ) : (
              <SchoolHeaderLinks props={props} />
            )}
          </div>

          {!shrinked && props.isMainSchoolTab && (
            <div
              className={`col login-panel f-ac f-je ${props.schoolSectionHeader}`}
            >
              <UserLoginName pathName={pathname} />
              <ChangeChoiceLanguage isActive={shouldBeActive} />
            </div>
          )}
        </div>
      </div>

      <div className={`f-jc container ${props.schoolSectionHeader}`}>
        <div className="school-name-wrapper f-jc row">
          <div className="search_title school-title col-12">
            {props.school.name}
          </div>
          {props.school.isSummer ? (
            <div className="school-details text-center col-12">
              {t("school.header.founded")} {props.school.foundationYear}{" "}
              &nbsp;·&nbsp; {t("school.header.NumberStudyCentres")}:{" "}
              {props.school.studyCentersNumber}
            </div>
          ) : (
            <div className="school-details text-center col-12">
              {t("school.header.founded")} {props.school.foundationYear}{" "}
              &nbsp;·&nbsp;{props.school.settlement},{" "}
              {props.school.regionResolved}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SchoolHeaderSection
